
import Vue from 'vue';
import { Getter, Action } from 'vuex-class';
import Component from 'vue-class-component';
import SearchCustomer from './SearchCustomer.vue';
import SeatchEmployee from './SearchEmployee.vue';
import SearchProject from './SearchProject.vue';
import FileTable from './FileTable.vue';
import { Message } from 'element-ui';
import { Prop, Watch } from 'vue-property-decorator';
import * as util from '../conf';

@Component({
  components: { SearchCustomer, SeatchEmployee, SearchProject, FileTable }
})
export default class ProductDefect extends Vue {
  $refs: {
    [key: string]: any;
    validate: HTMLFormElement;
  };

  @Getter productSubsystemList: any;
  @Getter productModuleList: any;
  @Getter productEditionList: any;
  @Getter customerList: any;
  @Getter employeeList: any;
  @Getter projectList: any;
  @Getter feedbackResult: any;
  @Getter feedbackDetail: any;
  @Getter isSubmitBugByUser: any;
  @Getter defaultAssigneeByModule: any; // 模块默认经办人信息

  @Action('getProductSubsystemList') getProductSubsystemList: Function;
  @Action('getProductModuleList') getProductModuleList: Function;
  @Action('getProductEditionList') getProductEditionList: Function;
  @Action('getCustomerData') getCustomerData: Function;
  @Action('getEmpliyeeData') getEmpliyeeData: Function;
  @Action('getProjectData') getProjectData: Function;
  @Action('addFeedback') addFeedback: Function;
  @Action('getSaasEmpliyeeList') getSaasEmpliyeeList: Function;
  @Action('getFeedbackDetailById') getFeedbackDetailById: Function;
  @Action('getIsSubmitBugByUser') getIsSubmitBugByUser: Function;
  @Action('getDefaultAssigneeByModule') getDefaultAssigneeByModule: Function;
  @Prop() TypeEnum: number;
  @Prop() assignee: any;
  @Prop() defaultAssignee: any;

  userType: string = 'other';
  isActivation: boolean = false;
  chooseCustomerVisible: boolean = false;
  chooseEmployeeVisible: boolean = false;
  chooseProjectVisible: boolean = false;
  isShowEnterpriseCode: boolean = false;
  isShowPDInfo: boolean = true;
  subdisabled:boolean=false;
  newAss: any = {};
  subNameList: any[] = [
    { SubSystemName: '云助手', PmUserCode: 'zhaojj01' },
    { SubSystemName: 'HighData', PmUserCode: 'xuc02' },
    { SubSystemName: '工作流', PmUserCode: 'huj04' },
    { SubSystemName: '移动计划', PmUserCode: 'wujz01' },
    { SubSystemName: 'RDC平台', PmUserCode: 'huqw' }
  ];
  PMEdit: boolean = true; // 云助手、HighData、工作流、移动计划 二开PM带出且不能编辑
  tjUrl:String='https://open.mingyuanyun.com/developer/support/order';

  // 表单数据
  form: any = {
    EnterpriseCode: '',
    SubSystemGUID: '',
    SubSystemName: '',
    ModuleGUID: '',
    ModuleName: '',
    EditionGUID: '',
    EditionName: '',
    CustomerTopName: '',
    CustomerGUID: '',
    CustomerArea: '',
    CustomerFullName: '',
    CustomerShortName: '',
    PmName: '',
    PmUserCode: '',
    PmGUID: '',
    PmABU: '',
    ProjectGUID: '',
    ProjectName: '',
    FeedbackTheme: '',
    FeedbackDescribe: '',
    FileUpload: '',
    CompayType: '',
    FromType: '',   // 来源
    TicketId: '',    // 来源主键        
    assignee: { name: '' }
  };

  rules: any = {
    EnterpriseCode: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('企业代码不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    SubSystemGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('所属子系统不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    ModuleGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('模块不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    EditionGUID: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('产品版本不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    FeedbackTheme: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('咨询主题不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ],
    FeedbackDescribe: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (!value) return callback(new Error('产品问题现象不能为空'));
          callback();
        },
        trigger: 'blur'
      }
    ]
  };

 setsubdisabled(value:boolean) {    
    this.subdisabled=value;
 }

  checkCuetomer(rule: any, value: any, callback: any) {
    if (!value) return callback(new Error('客户名称不能为空'));
    if (
      !this.isActivation &&
      (!this.customerList.data ||
        !this.customerList.data.find(
          (item: any) => item.CustomerFullName === value
        ))
    ) {
      return callback(new Error('客户名称无效'));
    }
    callback();
  }

  checkProject(rule: any, value: any, callback: any) {
    if (!this.isShowPDInfo) callback();
    if (!value) return callback(new Error('项目名称不能为空'));
    if (
      !this.projectList.data ||
      !this.projectList.data.find((item: any) => item.ProjectName === value)
    ) {
      return callback(new Error('项目名称无效'));
    }
    callback();
  }

  checkPmName(rule: any, value: any, callback: any) {
    if (!this.PMEdit || !this.isShowPDInfo) callback();
    if (!value) return callback(new Error('二开PM不能为空'));
    if (
      !this.employeeList.data ||
      !this.employeeList.data.find((item: any) => item.PmName === value)
    ) {
      return callback(new Error('二开PM名字无效'));
    }
    callback();
  }

  created() {    
    const user = JSON.parse(localStorage.logonUser);
    this.reactivation();    
    this.userType = util.getUserAreaType();    
    this.getIsSubmitBugByUser({userCode:user.UserCode});    
    this.form.CompayType = this.userType;
    this.form.BUName = util.getUserBUName();
    this.getProductSubsystemList();
    if (this.userType !== 'other') {
      this.rules.PmName = [{ validator: this.checkPmName, trigger: 'blur' }];
      if (this.userType === 'zyqy') {
        this.rules.ProjectName = [
          { validator: this.checkProject, trigger: 'blur' }
        ];
      } else if (this.userType === 'qygs') {
        this.rules.CustomerFullName = {
          validator: this.checkCuetomer,
          trigger: 'blur'
        };
      }
    }
    
    this.form.FromType=this.$route.query.fromType;
    this.form.TicketId=this.$route.query.ticketId;
  }

  // 重新激活的处理过程
  reactivation() {
    if (
      this.$route.query.FeedbackGUID &&
      this.$route.query.FeedbackGUID !== ''
    ) {
      this.isActivation = true;
      this.form.OriginalFeedbackGUID = this.$route.query.FeedbackGUID;
      this.getFeedbackDetailById({
        FeedbackGUID: this.$route.query.FeedbackGUID
      });
    }
  }

  @Watch('feedbackDetail.loading')
  watchFeedbackDetail(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
      const data = JSON.parse(JSON.stringify(this.feedbackDetail.data));
      const detailInfo =
        data.length > 0
          ? data.find((item: any) => item.SourceEnum === 1) || data[0]
          : {};
      // 选择主系统
      this.form.SubSystemGUID = detailInfo.SubSystemGUID;
      this.form.SubSystemName = detailInfo.SubSystemName;
      this.setEnterpriseCode(this.form.SubSystemGUID);
      this.setPdCode(this.form.SubSystemGUID);
      this.form.EnterpriseCode = detailInfo.EnterpriseCode;
      // 选择模块
      this.getProductModuleList({
        subSystemName: detailInfo.SubSystemName
      });
      this.form.ModuleGUID = detailInfo.ModuleGUID;
      this.form.ModuleName = detailInfo.ModuleName;
      // 选择版本
      this.getProductEditionList({
        subSystemName: detailInfo.SubSystemName
      });
      this.form.EditionGUID = detailInfo.EditionGUID;
      this.form.EditionName = detailInfo.EditionName;
      // 二开PM名称
      this.getEmpliyeeData({
        keyword: detailInfo.PmName,
        isPage: false,
        top: 100
      });
      this.form.PmName = detailInfo.PmName;
      this.form.PmUserCode = detailInfo.PmUserCode;
      this.form.PmGUID = detailInfo.PmGUID;
      this.form.PmABU = detailInfo.PmABU;
      // 项目名称
      this.getProjectData({
        keyword: detailInfo.ProjectName,
        isPage: false,
        top: 100
      });
      this.form.ProjectGUID = detailInfo.ProjectGUID;
      this.form.ProjectName = detailInfo.ProjectName;
      // 输入客户名称
      this.getCustomerData({
        keyword: detailInfo.CustomerFullName,
        isPage: false,
        top: 100
      });
      this.form.CustomerTopName = detailInfo.CustomerTopName;
      this.form.CustomerGUID = detailInfo.CustomerGUID;
      this.form.CustomerArea = detailInfo.CustomerArea;
      this.form.CustomerFullName = detailInfo.CustomerFullName;
      this.form.CustomerShortName = detailInfo.CustomerShortName;
      // 主题
      this.form.FeedbackTheme = detailInfo.FeedbackTheme;
      // 描述
      this.form.FeedbackDescribe = detailInfo.FeedbackDescribe;
      // 原反馈分析
      this.form.OriginalAnalysis = detailInfo.Analysis;
      // 附件
      this.form.FileUpload = detailInfo.FileUpload;
      this.$refs.filetable.appendFileList(
        detailInfo.FileUpload ? JSON.parse(detailInfo.FileUpload) : []
      );
      // 经办人
      this.form.assignee.name = detailInfo.OperateUserCode;
      this.newAss.displayName = detailInfo.OperateName;
    }
  }

  @Watch('defaultAssignee.loading')
  watchDefaultAssignee(newVal: boolean, oldVal: boolean) {
    // oldVal: true, newVal: fasle, 表示接口请求完成，loading页面即将加载完成
    if (oldVal === true && newVal === false) {
      this.setEnterpriseCode(this.form.SubSystemGUID);
      this.setPdCode(this.form.SubSystemGUID);
    }
  }

  // 选择子系统
  changeSubsystem(key: any) {
    this.setAssignee(key);
    this.setEnterpriseCode(key);
    this.setPdCode(key);
    this.form.ModuleGUID = '';
    this.form.EditionGUID = '';
    this.form.CustomerFullName = '';
    this.form.EnterpriseCode = '';
    const subsystem = this.productSubsystemList.data.find(
      (item: any) => item.SubSystemGUID === key
    );
    if (subsystem) {
      this.getProductModuleList({
        subSystemName: subsystem.SubSystemName
      });
      this.getProductEditionList({
        subSystemName: subsystem.SubSystemName
      });
      this.setPMName(subsystem.SubSystemName);
      // 查找模块默认经办人信息
      this.getDefaultAssigneeByModule({
        subSystemName: subsystem.SubSystemName
      });
    }
    this.$refs.form.validateField('SubSystemGUID');
  }

  // 设置默认经办人
  setAssignee(sysid: any) {
    // 先置为空
    this.newAss={};
    this.form.assignee.name='';
    this.defaultAssignee.data.map((item: any) => {
      if (item.SubSystemGuid === sysid) {
        this.assignee.data.map((ass: any) => {
          if (ass.id === item.JiraUserId.toString()) {
            this.newAss = ass;
            this.form.assignee.name = ass.name;
          }
        });
      }
    });
  }

  // 设置是否需要填写企业代码
  setEnterpriseCode(sysid: any) {
    // 云助手 10808
    // HightData 10809
    // 移动计划 11192
    // 反馈流程测试 11333
    const needEnterpriseCodeSys = ['10808', '10809', '11192', '11333'];
    if (needEnterpriseCodeSys.includes(sysid)) {
      this.defaultAssignee.data.map((item: any) => {
        if (item.SubSystemGuid === sysid) {
          this.isShowEnterpriseCode = !item.IsHandleByProject;
        }
      });
    } else {
      this.isShowEnterpriseCode = false;
    }
  }

  setPdCode(sysid: any) {
    this.defaultAssignee.data.map((item: any) => {
      if (item.SubSystemGuid === sysid) {
        this.isShowPDInfo = !!item.IsHandleByProject;
      }
    });
  }

  // 选择模块
  changeModule(key: any) {
    this.$refs.form.validateField('ModuleGUID');
    // 获取模块默认经办人 如果存在替换经办人字段，如果不存在 不替换    
    var user = this.defaultAssigneeByModule.data.find((item:any) => item.ModuleGUID===key);
    if(user && user.JiraUserId != null){        
        this.assignee.data.map((ass:any)=>{
          if(ass.id === user.JiraUserId){
            this.newAss = ass;
            this.form.assignee.name = ass.name;
          }
        });
    }else if(user){
      // 如果模块没有设置默认经办人，默认经办人改为子系统默认经办人
      this.setAssignee(user.SubSystemGUID);
    }
  }

  // 选择子系统
  changeEdition(key: any) {
    this.$refs.form.validateField('EditionGUID');
  }

  // 客户搜索结果(value表示的是下拉的文字)
  queryCustomerAsync(keyword: string, cb: Function) {
    let customerResult: any = [];
    if (keyword) {
      this.getCustomerData({ keyword, isPage: false, top: 100 }).then(
        (data: any) => {
          if (data && data.Items) {
            data.Items.forEach(
              (item: any) => (item.value = item.CustomerFullName)
            );
            customerResult = data.Items;
          }
          cb(customerResult);
        }
      );
    } else {
      cb(customerResult);
    }
  }

  // 确定选择的客户（模糊搜索）
  handleSelectCustomer(item: any) {
    this.form.CustomerGUID = item.CustomerGUID;
    this.form.CustomerArea = item.CustomerArea; // 客户区域
    this.form.CustomerFullName = item.CustomerFullName; // 客户全称
    this.form.CustomerTopName = item.CustomerTopName; // 顶级客户(简称)
    this.form.CustomerShortName = item.CustomerShortName; // 客户简称
    this.$refs.form.validateField('CustomerFullName');
  }

  // 打开选择客户弹窗
  chooseCustomer() {
    if (this.userType !== 'zyqy' || !this.isShowPDInfo) {
      this.chooseCustomerVisible = true;
    }
  }

  // 关闭选择客户
  closeChooseCustomerVisible(close: boolean) {
    this.chooseCustomerVisible = false;
  }

  // 确定选择客户（弹窗选择）
  confirmSelectedCustomer(val: { [key: string]: any }) {
    if (!!val) {
      this.form.CustomerGUID = val.CustomerGUID; // 客户GUID
      this.form.CustomerArea = val.CustomerArea; // 客户区域
      this.form.CustomerFullName = val.CustomerFullName; // 客户全称
      this.form.CustomerTopName = val.CustomerTopName; // 顶级客户(简称)
      this.form.CustomerShortName = val.CustomerShortName; // 客户简称
    }
    this.chooseCustomerVisible = false;
    this.$refs.form.validateField('CustomerFullName');
  }

  // 人员搜索结果(value表示的是下拉的文字)
  queryEmployeeAsync(keyword: string, cb: Function) {
    let employeeResult: any = [];
    if (keyword) {
      this.getEmpliyeeData({ keyword, isPage: false, top: 100 }).then(
        (data: any) => {
          if (data && data.Items) {
            data.Items.forEach((item: any) => (item.value = item.PmName));
            employeeResult = data.Items;
          }
          cb(employeeResult);
        }
      );
    } else {
      cb(employeeResult);
    }
  }

  // 确定人员的选择（模糊搜索）
  handleSelectEmployee(item: any) {
    this.form.PmName = item.PmName;
    this.form.PmUserCode = item.PmUserCode;
    this.form.PmGUID = item.PmGUID;
    this.form.PmABU = item.PmABU;
    this.$refs.form.validateField('PmName');
  }

  // 清除人员的选择
  handleClearEmployee() {
    this.form.PmName = '';
    this.form.PmUserCode = '';
    this.form.PmGUID = '';
    this.form.PmABU = '';
    this.$refs.form.clearValidate('PmName');
  }

  // 云助手、HighData、工作流、移动计划 二开PM带出且不能编辑
  setPMName(SubSystemName: string) {
    const sub = this.subNameList.find((it) => it.SubSystemName === SubSystemName);
    if (sub) {
      // 调接口
      this.getSaasEmpliyeeList({ isPage: false, top: 100 }).then(
        (data: any) => {
          if (data && data.Items) {
            const item = data.Items.find(
              (it: any) => it.PmUserCode === sub.PmUserCode
            );
            if (item && item.PmName) {
              item.value = item.PmName;
              this.handleSelectEmployee(item);
            }
          }
        }
      );
      this.PMEdit = false;
    } else {
      this.handleClearEmployee();
      this.PMEdit = true;
    }
  }

  // 打开选择人员弹窗
  chooseEmployee() {
    this.chooseEmployeeVisible = true;
  }

  // 关闭选择人员弹窗
  closeChooseEmployeeVisible(close: boolean) {
    this.chooseEmployeeVisible = false;
  }

  // 确认选择人员
  confirmSelectedEmployee(val: { [key: string]: any }) {
    if (!!val) {
      this.form.PmName = val.PmName;
      this.form.PmUserCode = val.PmUserCode;
      this.form.PmGUID = val.PmGUID;
      this.form.PmABU = val.PmABU;
    }
    this.chooseEmployeeVisible = false;
    this.$refs.form.validateField('PmName');
  }

  // 项目搜索结果(value表示的是下拉的文字)
  queryProjectAsync(keyword: string, cb: Function) {
    let projectResult: any = [];
    if (keyword) {
      this.getProjectData({ keyword, isPage: false, top: 100 }).then(
        (data: any) => {
          if (data && data.Items) {
            data.Items.forEach((item: any) => (item.value = item.ProjectName));
            projectResult = data.Items;
          }
          cb(projectResult);
        }
      );
    } else {
      cb(projectResult);
    }
  }

  // 确定选择的项目（模糊搜索）
  handleSelectProject(item: any) {
    this.form.ProjectGUID = item.ProjectGUID;
    this.form.ProjectName = item.ProjectName;
    if (this.userType === 'zyqy') {
      this.form.CustomerGUID = item.CustomerGUID;
      this.form.CustomerFullName = item.CustomerFullName;
      this.form.CustomerShortName = item.CustomerShortName;
      this.form.CustomerTopName = item.CustomerTopName;
      this.form.ContractCode = item.ContractCode;
      this.form.ContractGUID = item.ContractGUID;
    }
    this.$refs.form.validateField('ProjectName');
  }

  // 打开选择项目弹窗
  chooseProject() {
    this.chooseProjectVisible = true;
  }

  // 关闭选择项目弹窗
  closeChooseProjectVisible(close: boolean) {
    this.chooseProjectVisible = false;
  }

  // 确认选择项目
  confirmSelectedProject(val: { [key: string]: any }) {
    if (!!val) {
      this.form.ProjectGUID = val.ProjectGUID;
      this.form.ProjectName = val.ProjectName;
      if (this.userType === 'zyqy') {
        this.form.CustomerGUID = val.CustomerGUID;
        this.form.CustomerFullName = val.CustomerFullName;
        this.form.CustomerShortName = val.CustomerShortName;
        this.form.CustomerTopName = val.CustomerTopName;
        this.form.ContractCode = val.ContractCode;
        this.form.ContractGUID = val.ContractGUID;
      }
    }
    this.chooseProjectVisible = false;
    this.$refs.form.validateField('ProjectName');
  }

  confirmFileList(fileList: any[]) {
    this.form.FileUpload = JSON.stringify(fileList);
  }

  // 提交表单
  onSubmit(formName: string) {
    // // 云客服支持提单，  如果不是云客服升级单 && 没有提BUG单权限。不允许提交单据。
    // if(this.form.FromType!='ykf'&&this.isSubmitBugByUser.data==false){
    //   this.$alert("项目体系（含ODC）、运维体系，请通过升级通道提交产品BUG。",{center: true});
    //   return ;
    // }
    const form = this.$refs[formName];
    form.validate((valid: any) => {
      if (valid) {
        this.subdisabled=true;
        this.form.TypeEnum = this.TypeEnum;
        const subsystem = this.productSubsystemList.data.find(
          (item: any) => item.SubSystemGUID === this.form.SubSystemGUID
        );
        this.form.SubSystemName = subsystem.SubSystemName;
        const moduleInfo = this.productModuleList.data.find(
          (item: any) => item.ModuleGUID === this.form.ModuleGUID
        );
        this.form.ModuleName = moduleInfo.ModuleName;
        const edition = this.productEditionList.data.find(
          (item: any) => item.EditionGUID === this.form.EditionGUID
        );
        this.form.EditionName = edition.EditionName;
        // 防止重复提交
        if (
          !this.feedbackResult.success ||
          this.feedbackResult.request.FeedbackTheme !== this.form.FeedbackTheme
        ) {
          const body = Object.assign({}, this.form); // 解决接口报错时，重复叠加data的问题
          this.addFeedback(body);
        } else {
          Message.success(this.feedbackResult.Message);    
          this.subdisabled=false;      
        }
      } else {
        return false;
      }
    });
  }
}
